<script setup lang="ts">
// The app's single icon primitive. Every icon in the UI renders through this so
// the icon set lives in ONE place (lib/icons.ts): swap a name's Iconify id there
// and it changes everywhere, no call-site edits. `name` is type-checked against
// the registry, so a typo or a removed icon is a compile error. Renders via
// Iconify (icon data loads on demand). Phosphor's `weight` has no equivalent and
// is intentionally dropped; the chosen set's default weight applies.
//
// Usage: <AppIcon name="house" :size="18" />  (class/style fall through to the svg)
import { computed } from 'vue';
import { Icon } from '@iconify/vue';
import { ICONS, type IconName } from '@/lib/icons';

const props = withDefaults(defineProps<{
  name: IconName;
  size?: number | string;
}>(), { size: 18 });

const icon = computed(() => ICONS[props.name]);
</script>

<template>
  <Icon :icon="icon" :width="size" :height="size" />
</template>
